import { t } from "../../hooks/useAppTranslation";
import { Formik, Form } from "formik";
import Input from "../Input/Input";

type Props = {
  handleSaveDict(data: any): void;
  handleClose(): void;
  label: string
};

export const NewDictValueForm: React.FC<Props> = ({
  handleSaveDict,
  handleClose,
  label
}) => {
  return (
    <Formik
      enableReinitialize={true}
      onSubmit={(values) => {
        handleSaveDict(values);
      }}
      initialValues={{
        name: "",
        active: true
      }}
    >
      {({ values, handleChange }) => {
        return (
          <Form>
            <Input
              type='text'
              name='name'
              inputId='n-dict-name'
              onChange={handleChange}
              label={label}
              chartsCount={values.name.length}
              maxLength={500}
              formik={true}
            />
            <div className='btn_group'>
              <button className='btn save-btn uppercase' id='save_button' type='submit'>
                {t('g-save')}
              </button>
              <button
                className='btn cancel-btn uppercase'
                type='button'
                onClick={() => handleClose()}
              >
                {t('g-cancel')}
              </button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
